import { HttpService } from './services/http.service';
import { ApiService } from './services/api.service';

export default angular
  .module('mcp.admin.api', ['mcb', 'mcp.admin.monitoring'])
  .service('mcpAdminHttpService', HttpService)
  .service('mcpAdminApi', ApiService);
